export default __webpack_public_path__ + "static/media/lavics.54c0845e.jpeg";